<template>
  <div
    v-if="faqItems.length > 1"
    class="flex flex-wrap justify-center gap-3"
  >
    <button
      v-for="(item, index) in faqItems"
      :key="index"
      class="py-2.5 px-4 leading-3 flex-center font-semibold border
        border-green-500 text-green-500 bg-white rounded-full
        hover:bg-green-500 hover:text-white focus:bg-green-500 focus:text-white"
      :data-gtm-action="`scroll to ${item}`"
      @click="scrollToItem(item)"
    >
      {{ item }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { scrollToSelector } from '@/utils'
import { onMounted, ref } from 'vue'

const faqItems = ref<string[]>([])

const scrollToItem = (item: string) => {
  scrollToSelector(`[data-button-title="${item}"]`, 20)
}

onMounted(() => {
  const elements = document.querySelectorAll('[data-button-title]')
  faqItems.value = Array.from(elements).map(element => (element as HTMLElement).dataset.buttonTitle || '')
})
</script>
